import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "../../lib/api";
import { ActionButton } from "../common";

const messages = {
  queued: "Update email queued for the Requestor",
  sending: "Sending update email to the Requestor…",
  sent: "Update email accepted by the email provider",
  failed: "Work order saved, but the update email could not be sent",
  missing_requestor_email: "Work order saved. The Requestor needs an active user account with an email address",
  recipient_unavailable: "Work order saved. The Requestor’s account or email changed before sending",
  rate_limited: "Work order saved. Email limit reached; retry in five minutes",
};
export const WorkOrderUpdateStatus = ({ order, canRetry }) => {
  const [notice, setNotice] = useState(order.update_email || null), [error, setError] = useState(""), [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setNotice((await api.get(`/fleet/work-orders/${order.id}/update-email`)).data); setError(""); }
    catch (e) { setError(errMsg(e)); }
  }, [order.id]);
  useEffect(() => { load(); }, [load, order.version]);
  useEffect(() => {
    if (!notice || !["queued", "sending"].includes(notice.status)) return;
    const timer = setInterval(load, 2000); return () => clearInterval(timer);
  }, [notice, load]);
  const retry = async () => {
    setBusy(true); setError("");
    try { await api.post(`/fleet/work-orders/${order.id}/update-email/retry`); await load(); }
    catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
  };
  if (!notice && !error) return null;
  return <section data-testid="wo-update-email-panel" className="rounded border border-slate-300 p-3 space-y-2 text-sm break-words" aria-live="polite">
    {notice && <><p data-testid="wo-update-email-status">{messages[notice.status] || notice.status}</p><p data-testid="wo-update-email-recipient" className="text-xs">{notice.subject}{notice.recipient_email && ` · ${notice.recipient_email}`}</p></>}
    {error && <p role="alert" data-testid="wo-update-email-error" className="text-red-700">{error}</p>}
    {canRetry && notice && ["failed", "missing_requestor_email", "recipient_unavailable", "rate_limited"].includes(notice.status) && <ActionButton testId="wo-update-email-retry" type="button" variant="secondary" disabled={busy} onClick={retry}>{busy ? "Retrying…" : "Retry Update Email"}</ActionButton>}
  </section>;
};
